export const initialState = {
    step: 1,
    formData: {
        channelName: '',
        url: '',
        files: [],
        urlFile: null,
    },
    formError: {
        channelName: '',
        url: '',
        files: '',
        urlFile: '',
    },
    uploadType: 'LOCAL_UPLOAD',
    pkgUploadStatus: {
        successRecords: [],
        failedRecords: [],
    },
    pkgExistStatus: {
        exist: {},
        notExist: {},
    },
}
